import { useContext } from 'react';
import PropTypes from 'prop-types';
import { Placeholder } from 'react-bootstrap';
import { COMMON_CURRENCY_PRECISION, CRYPTO_CURRENCY_PRECISION } from 'components/constants';
import i18nContext from 'components/i18n-context';
import { useApplicationContext } from 'contexts/ApplicationContext';
import { formatDateTime, formatMoney, getAllCryptoCurrencies, isCryptoCurrency } from 'services/utils';
import { CheckBox } from 'uikit/CheckBox/CheckBox';
import './CurrencyPairsTableRowContent.scss';
import Button from '../../../../../../uikit/Button/Button';

export const CurrencyPairsTableRowContent = ({
  isLoading,
  handleChangeCurrencyPairStatus,
  handleChangeCurrencyPairManual,
  currencyPairData,
  handleOpenUpdateCurrencyPairPopUp
}) => {
  const i18n = useContext(i18nContext);
  const { constants } = useApplicationContext();
  const allCryptoCurrencies = getAllCryptoCurrencies(constants);

  const getCurrencyPairInfoBlock = (
    currencyPairBlockInfo,
    isCurrencyPairStatus = false,
    isCurrencyPairManual = false,
    isUpdateButton = false
  ) => {
    if (isLoading) {
      return (
        <Placeholder as={'p'} animation={'glow'}>
          <Placeholder className={'currency-pairs-loader-placeholder'} xs={12} bg={'secondary'} />
        </Placeholder>
      );
    } else if (isCurrencyPairStatus) {
      return (
        <div className={'currency-pairs-settings-wrapper'}>
          <CheckBox
            className={'currency-pairs-checkbox'}
            name={'active'}
            isActive={currencyPairBlockInfo}
            isReverseView={true}
            showCheckBox={true}
            onChange={() => handleChangeCurrencyPairStatus(currencyPairData, !currencyPairBlockInfo)}
            value={i18n.getMessage('currencyPairs.table.rowContent.status.active')}
            disabled={isLoading}
          />
        </div>
      );
    } else if (isCurrencyPairManual) {
      return (
        <div className={'currency-pairs-settings-wrapper'}>
          <CheckBox
            className={'currency-pairs-checkbox'}
            name={'active'}
            isActive={currencyPairBlockInfo}
            isReverseView={true}
            showCheckBox={true}
            onChange={() => handleChangeCurrencyPairManual(currencyPairData, !currencyPairBlockInfo)}
            value={i18n.getMessage('currencyPairs.table.rowContent.manual')}
            disabled={isLoading}
          />
        </div>
      );
    } else if (isUpdateButton) {
      return (
        <Button onClick={() => handleOpenUpdateCurrencyPairPopUp(currencyPairData)} type={'primary'} size={'small'}>
          {i18n.getMessage('currencyPairs.table.rowContent.button.update')}
        </Button>
      );
    } else {
      return <p>{currencyPairBlockInfo}</p>;
    }
  };

  return (
    <tr>
      <td className={'currency-pairs-table-cell'}>{getCurrencyPairInfoBlock(currencyPairData.from)}</td>
      <td className={'currency-pairs-table-cell'}>
        {getCurrencyPairInfoBlock(
          formatMoney(
            currencyPairData.manualMinAmount,
            isCryptoCurrency(currencyPairData.from, allCryptoCurrencies)
              ? CRYPTO_CURRENCY_PRECISION
              : COMMON_CURRENCY_PRECISION
          )
        )}
      </td>
      <td className={'currency-pairs-table-cell'}>{getCurrencyPairInfoBlock(currencyPairData.to)}</td>
      <td className={'currency-pairs-table-cell'}>
        {getCurrencyPairInfoBlock(formatDateTime(currencyPairData.created_at))}
      </td>
      <td className={'currency-pairs-table-cell'}>{getCurrencyPairInfoBlock(currencyPairData.active, true)}</td>
      <td className={'currency-pairs-table-cell'}>{getCurrencyPairInfoBlock(currencyPairData.manual, false, true)}</td>
      <td className={'currency-pairs-table-cell'}>{getCurrencyPairInfoBlock(currencyPairData, false, false, true)}</td>
    </tr>
  );
};

CurrencyPairsTableRowContent.propTypes = {
  isLoading: PropTypes.bool,
  handleChangeCurrencyPairStatus: PropTypes.func,
  handleChangeCurrencyPairManual: PropTypes.func,
  handleOpenUpdateCurrencyPairPopUp: PropTypes.func,
  currencyPairData: PropTypes.shape({
    from: PropTypes.string,
    to: PropTypes.string,
    manualMinAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    created_at: PropTypes.string,
    active: PropTypes.bool,
    manual: PropTypes.bool
  })
};
